/* CUBA CONTADA — comportamiento propio (prefijo cc-) */
(function () {
  if (window.__ccInit) return;
  window.__ccInit = true;

  var doc = document.documentElement;
  doc.classList.add('cc-js');
  var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observador = null;
  if ('IntersectionObserver' in window) {
    observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('cc-visible');
          observador.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }
  function initReveals(raiz) {
    (raiz || document).querySelectorAll('.cc-reveal, [data-cc-reveal]').forEach(function (el) {
      if (el.dataset.ccInit) return;
      el.dataset.ccInit = '1';
      if (!observador || sinMovimiento) { el.classList.add('cc-visible'); return; }
      observador.observe(el);
    });
  }

  /* ---------- Banda de sellos: duplica el contenido hasta cubrir 2 anchos ---------- */
  function initBandas(raiz) {
    (raiz || document).querySelectorAll('[data-cc-banda]').forEach(function (banda) {
      if (banda.dataset.ccInit) return;
      banda.dataset.ccInit = '1';
      var pista = banda.querySelector('.cc-banda__pista');
      var grupo = pista && pista.querySelector('.cc-banda__grupo');
      if (!grupo || !grupo.offsetWidth) return;
      var copias = Math.max(1, Math.ceil(window.innerWidth / grupo.offsetWidth));
      var mitad = document.createDocumentFragment();
      for (var i = 0; i < copias - 1; i++) mitad.appendChild(grupo.cloneNode(true));
      pista.appendChild(mitad);
      // segunda mitad idéntica: la animación recorre exactamente el 50 %
      Array.prototype.slice.call(pista.children).forEach(function (g) {
        var c = g.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        pista.appendChild(c);
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function dinero(centimos, formato) {
    var n = (centimos / 100).toFixed(2);
    var conComas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!formato) return '$' + conComas;
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, tipo) {
      if (tipo === 'amount_no_decimals') return Math.round(centimos / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (tipo === 'amount_with_comma_separator') return n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return conComas;
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-cc-producto]').forEach(function (prod) {
      if (prod.dataset.ccInit) return;
      prod.dataset.ccInit = '1';

      /* Galería */
      var slides = prod.querySelectorAll('.cc-gal__slide');
      var thumbs = prod.querySelectorAll('.cc-gal__thumb');
      function verFoto(id) {
        var hallada = false;
        slides.forEach(function (s) { if (s.dataset.mediaId === String(id)) hallada = true; });
        if (!hallada) return;
        slides.forEach(function (s) { s.classList.toggle('cc-activa', s.dataset.mediaId === String(id)); });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.mediaId === String(id) ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { verFoto(t.dataset.mediaId); }); });

      /* Variantes: color y talla */
      var datos = prod.querySelector('[data-cc-variantes]');
      var form = prod.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('input[name="id"]');
      var boton = form && form.querySelector('[type="submit"]');
      var precioEls = prod.querySelectorAll('[data-cc-precio]');
      var formato = prod.dataset.formatoDinero;
      var txtAnadir = boton ? boton.dataset.txtAnadir : '';
      var txtAgotado = boton ? boton.dataset.txtAgotado : '';
      var txtNoDisp = boton ? boton.dataset.txtNoDisponible : '';
      var variantes = [];
      try { variantes = datos ? JSON.parse(datos.textContent) : []; } catch (e) { variantes = []; }
      var grupos = prod.querySelectorAll('[data-cc-opcion]');

      function seleccion() {
        var sel = [];
        grupos.forEach(function (g) {
          var marcado = g.querySelector('input:checked');
          sel[Number(g.dataset.ccOpcion)] = marcado ? marcado.value : null;
        });
        return sel;
      }
      function buscar(sel) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i], ok = true;
          for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function pintarPrecio(v) {
        precioEls.forEach(function (el) {
          var html = dinero(v.price, formato);
          if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + dinero(v.compare_at_price, formato) + '</s>';
          el.innerHTML = html;
        });
      }
      function actualizar(cambiaUrl) {
        if (!variantes.length || !grupos.length) return;
        var sel = seleccion();
        var v = buscar(sel);
        // texto del valor elegido junto a la etiqueta
        grupos.forEach(function (g) {
          var b = g.querySelector('[data-cc-valor]');
          var marcado = g.querySelector('input:checked');
          if (b && marcado) b.textContent = marcado.dataset.etiqueta || marcado.value;
        });
        // marca como agotados los valores sin existencias para la combinación actual
        grupos.forEach(function (g) {
          var idx = Number(g.dataset.ccOpcion);
          g.querySelectorAll('input').forEach(function (inp) {
            var prueba = sel.slice();
            prueba[idx] = inp.value;
            var pv = buscar(prueba);
            inp.parentNode.classList.toggle('cc-talla--agotada', !pv || !pv.available);
          });
        });
        if (!boton || !inputId) return;
        if (!v) {
          boton.disabled = true;
          boton.querySelector('[data-cc-boton-txt]').textContent = txtNoDisp;
          return;
        }
        inputId.value = v.id;
        boton.disabled = !v.available;
        boton.querySelector('[data-cc-boton-txt]').textContent = v.available ? txtAnadir : txtAgotado;
        pintarPrecio(v);
        if (v.featured_media && v.featured_media.id) verFoto(v.featured_media.id);
        if (cambiaUrl && window.history && window.history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        var fijaPrecio = document.querySelector('[data-cc-fija-detalle]');
        if (fijaPrecio) {
          var nombres = [];
          grupos.forEach(function (g) { var m = g.querySelector('input:checked'); if (m && !g.hidden) nombres.push(m.dataset.etiqueta || m.value); });
          fijaPrecio.textContent = nombres.length ? nombres.join(' · ') : fijaPrecio.textContent;
        }
      }
      grupos.forEach(function (g) { g.addEventListener('change', function () { actualizar(true); }); });
      actualizar(false);

      /* Guía de tallas */
      var dialogo = prod.querySelector('[data-cc-dialogo-tallas]');
      prod.querySelectorAll('[data-cc-abrir-tallas]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!dialogo) return;
          if (dialogo.showModal) dialogo.showModal(); else dialogo.setAttribute('open', '');
        });
      });
      if (dialogo) {
        dialogo.querySelectorAll('[data-cc-cerrar]').forEach(function (b) {
          b.addEventListener('click', function () { if (dialogo.close) dialogo.close(); else dialogo.removeAttribute('open'); });
        });
        dialogo.addEventListener('click', function (e) { if (e.target === dialogo && dialogo.close) dialogo.close(); });
      }

      /* Barra fija en celular: aparece cuando el botón principal sale de pantalla */
      var fija = prod.querySelector('[data-cc-fija]');
      if (fija && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { fija.classList.toggle('cc-activa', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }, { threshold: 0 }).observe(boton);
        var botonFija = fija.querySelector('[data-cc-fija-boton]');
        if (botonFija) botonFija.addEventListener('click', function () {
          if (boton.disabled) { boton.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' }); return; }
          if (form.requestSubmit) form.requestSubmit(boton); else form.submit();
        });
      }
    });
  }

  /* ---------- Artículo: barra de lectura y botón de compra fijo ---------- */
  function initArticulo(raiz) {
    (raiz || document).querySelectorAll('[data-cc-articulo]').forEach(function (art) {
      if (art.dataset.ccInit) return;
      art.dataset.ccInit = '1';
      var barra = document.querySelector('.cc-leer i');
      var fija = document.querySelector('[data-cc-fija-articulo]');
      var cuerpo = art.querySelector('.cc-prosa') || art;
      var pendiente = false;
      function medir() {
        pendiente = false;
        var r = cuerpo.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.6;
        var avance = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        if (barra) barra.style.transform = 'scaleX(' + avance.toFixed(4) + ')';
        if (fija) fija.classList.toggle('cc-activa', r.top < -220 && r.bottom > window.innerHeight * 0.5);
      }
      window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(medir); } }, { passive: true });
      medir();
    });
  }

  /* ---------- Carrusel de historias ---------- */
  function initCarruseles(raiz) {
    (raiz || document).querySelectorAll('[data-cc-carrusel]').forEach(function (c) {
      if (c.dataset.ccInit) return;
      c.dataset.ccInit = '1';
      var pista = c.querySelector('.cc-carrusel__pista');
      var puntos = c.querySelector('.cc-carrusel__puntos');
      var prev = c.querySelector('[data-dir="-1"]');
      var next = c.querySelector('[data-dir="1"]');
      var items = Array.prototype.slice.call(pista.children);
      var paginas = 0, pendiente = false;
      function paso() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : pista.clientWidth; }
      function destino(i) {
        var it = items[i]; if (!it) return 0;
        if (getComputedStyle(it).scrollSnapAlign.indexOf('center') > -1) return it.offsetLeft - (pista.clientWidth - it.offsetWidth) / 2;
        return it.offsetLeft - (parseFloat(getComputedStyle(pista).scrollPaddingLeft) || 0);
      }
      function actual() {
        var max = pista.scrollWidth - pista.clientWidth;
        if (pista.scrollLeft >= max - 2) return paginas - 1;
        var mejor = 0, dist = Infinity;
        for (var i = 0; i < paginas; i++) { var d = Math.abs(destino(i) - pista.scrollLeft); if (d < dist) { dist = d; mejor = i; } }
        return mejor;
      }
      function ir(i) {
        i = Math.max(0, Math.min(paginas - 1, i));
        pista.scrollTo({ left: destino(i), behavior: sinMovimiento ? 'auto' : 'smooth' });
      }
      function pintar() {
        pendiente = false;
        var a = actual();
        Array.prototype.forEach.call(puntos.children, function (p, i) { p.setAttribute('aria-current', i === a ? 'true' : 'false'); });
        if (prev) prev.disabled = a <= 0;
        if (next) next.disabled = a >= paginas - 1;
      }
      function montar() {
        var desborda = pista.scrollWidth > pista.clientWidth + 2;
        c.classList.toggle('cc-carrusel--fijo', !desborda);
        var visibles = Math.max(1, Math.round(pista.clientWidth / paso()));
        paginas = desborda ? Math.max(1, items.length - visibles + 1) : 1;
        puntos.innerHTML = '';
        for (var i = 0; i < paginas; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'cc-carrusel__punto';
          b.setAttribute('aria-label', 'Ir a la historia ' + (i + 1));
          b.addEventListener('click', (function (n) { return function () { ir(n); }; })(i));
          puntos.appendChild(b);
        }
        pintar();
      }
      if (prev) prev.addEventListener('click', function () { ir(actual() - 1); });
      if (next) next.addEventListener('click', function () { ir(actual() + 1); });
      pista.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(montar, 150); });
      montar();
    });
  }

  function init(raiz) {
    initReveals(raiz);
    initBandas(raiz);
    initProducto(raiz);
    initArticulo(raiz);
    initCarruseles(raiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
